<template>
  <div class="pega-print-button-area">
    <button
      class="boss-button pega-print-button"
      data-test="print"
      @click="print"
    >
      <img src="@/assets/images/icon-print-secondary.svg">
      <span>印刷</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isSimple: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    print () {
      // シンプルに印刷のみの場合は印刷を呼ぶ。
      // その他の処理も実施が必要な場合はイベントを親へ移譲する
      // 例）親側でwindow.printイベント発火前にstatusを変更する実装の例
      // <print-button
      //   class="cell shrink"
      //   :is-simple="false"
      //   @print="print"
      // />
      // async print () {
      //   await this.changePrintStatus(true)
      //   window.print()
      // },
      this.isSimple ? window.print() : this.$emit('print')
    }
  }
}
</script>
